import { render } from "./VirtualConverterSettingsModal.vue?vue&type=template&id=4e2e0254"
import script from "./VirtualConverterSettingsModal.vue?vue&type=script&lang=js"
export * from "./VirtualConverterSettingsModal.vue?vue&type=script&lang=js"
script.render = render

export default script